var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dzsw"},[_c('a',{attrs:{"href":"http://content.dzzgsw.com/website/weixin/index.html"}},[_c('img',{attrs:{"src":_vm.ico1}})])])}
var staticRenderFns = []
export { render, staticRenderFns }